import { FC, useState } from 'react';

import { Button } from '@purpur/library';
import { IconClose } from '@purpur/library/icon/close';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';

import { MaintenanceBanner as MaintenanceBannerModel } from '../../model';
import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { CloseButtonWrapper, ContentContainer, StyledMaintenanceBanner } from './MaintenanceBanner.styles';

type Props = {
    data: MaintenanceBannerModel;
    onClose: (data: MaintenanceBannerModel) => void;
};

export const MaintenanceBanner: FC<Props> = ({ data, onClose }) => {
    const [isOpen, setIsOpen] = useState(true);
    const { t } = useTranslations();
    const colorOption = data.colorOption || 'beige';

    if (!isOpen) {
        return null;
    }

    return (
        <StyledMaintenanceBanner data-test={NAVIGATION_TEST_IDS.MAINTENANCE_BANNER} $color={colorOption}>
            <ContentContainer $color={colorOption}>
                <HtmlContent content={data.contentHtml} />
                <CloseButtonWrapper>
                    <Button
                        onClick={() => {
                            onClose(data);
                            setIsOpen(false);
                        }}
                        aria-label={t['common.button.close']}
                        variant="tertiary-purple"
                        iconOnly={true}
                        size="md"
                        type="button"
                        data-test={NAVIGATION_TEST_IDS.MAINTENANCE_BANNER_CLOSE_BUTTON}
                    >
                        <IconClose aria-hidden={true} size="sm" />
                    </Button>
                </CloseButtonWrapper>
            </ContentContainer>
        </StyledMaintenanceBanner>
    );
};
